// extracted by mini-css-extract-plugin
module.exports = {"hero":"page_hero__n3cUH","heroContent":"page_heroContent__oYoDB","title":"page_title__2c36K","subtitle":"page_subtitle__blUiZ","postsSection":"page_postsSection__AOMYR"};
module.exports.__checksum = "9b98ea23f399"
